module.exports = __webpack_public_path__ + "media/packs/images/flags/SC-2bb8b95e51b6e3ab69a938c43ec84c5f.png";